













import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { Point, Size } from "../../../../../../../base/domain/drawing";
import { IFormatObjectEditable } from "../../../../../../domain/editableFormat";
import { instanceOfIRectangleCoordinateEditable } from "../../../../../../domain/editableFormat/properties";
import { NewObjectLocatableMixin } from "./mixins";

@Component
export default class PositionCorrectionObjectLocator extends Mixins(NewObjectLocatableMixin) {
  get containsPositionCrrectionObjects(): boolean {
    return Enumerable.from(this.objects)
      .any(x => this.isPositionCorrectionObject(x));
  }

  layoutPositionCorrection(width: number = 0, height: number = 0): void {
    this.addLocatedObjects(this.createPositionCorrectionObjects(width, height));
  }

  private createPositionCorrectionObjects(width: number, height: number): IFormatObjectEditable[] {
    return Enumerable.from([
      new Point(0, 0),
      new Point(0, this.image.size.height - height),
      new Point(this.image.size.width - width, 0),
    ])
    .select(p => this.createPositionCorrectionObject(p, width, height))
    .toArray();
  }

  private createPositionCorrectionObject(location: Point, width: number, height: number): IFormatObjectEditable {
    const object = this.createNewObject(this.locatorKey);
    if (!instanceOfIRectangleCoordinateEditable(object)) {
      return;
    }
    object.location().setValue(Point.to(location));
    object.size().setValue(Size.to(new Size(width, height)));
    return object;
  }

  removePositionCorrectionObjects(): void {
    this.writePropertyWhenValid(s => {
      for (const o of this.getPositionCorrectionObjects().concat().reverse()) { // indexがずれないよう後ろから削除する.破壊しないようにconcat()でshallow copyしてから.
        s.removeObject(o);
      }
    });
    this.located();
  }

  getPositionCorrectionObjects(): IFormatObjectEditable[] {
    return Enumerable.from(this.objects)
      .where(x => this.isPositionCorrectionObject(x))
      .toArray();
  }

  isPositionCorrectionObject(source: IFormatObjectEditable): boolean {
    return (source.objectTypeName().getValue() === "poscorrect");
  }
}
